rdefine('app/formular/models/FormModel',['backbone','app/formular/collections/UIElementsCollection'],function(Backbone,UIEllementsCollection) {
    var _uiColelcton=null;
    return Backbone.Ribs.Model.extend({
        defaults: {
            label:'',
            required:false,
            placeholder:''
        },
        initialize:function() {
            if(!_uiColelcton) {
                _uiColelcton = new UIEllementsCollection();
            }
            if(!this.has("base.component")) {
                console.log("GEn bas",_uiColelcton.findWhere({type:this.get("base.type")}).attributes);
                this.set("base",_uiColelcton.findWhere({type:this.get("base.type")}).attributes,{slient:true});
            }
            //check base
        }
    });
});